<template>
  <b-modal
    id="modal-create-announcement"
    ref="modal-create-announcement"
    :visible="visible"
    title="Create Announcement"
    ok-title="Publish"
    cancel-title="Cancel"
    @ok="handleOk"
    @hidden="handleHidden"
    size="md"
    :ok-disabled="creatingAnnouncement"
  >
    <b-form @submit.prevent="handleOk">
      <b-form-group label-for="announcement-title">
        <template #label>
          Title <span class="text-danger">*</span>
        </template>
        <b-form-input
          id="announcement-title"
          v-model="announcementForm.title"
          placeholder="Enter announcement title"
          :state="titleState"
          :disabled="creatingAnnouncement"
        />
        <b-form-invalid-feedback :state="titleState">
          Title is required.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-for="announcement-date">
        <template #label>
          Date <span class="text-danger">*</span>
        </template>
        <b-form-input
          id="announcement-date"
          v-model="announcementForm.date"
          type="date"
          :state="dateState"
          :disabled="creatingAnnouncement"
        />
        <b-form-invalid-feedback :state="dateState">
          Date is required.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-for="announcement-message">
        <template #label>
          Message <span class="text-danger">*</span>
        </template>
        <b-form-textarea
          id="announcement-message"
          v-model="announcementForm.message"
          placeholder="Enter announcement message"
          rows="5"
          :state="messageState"
          :disabled="creatingAnnouncement"
        />
        <b-form-invalid-feedback :state="messageState">
          Message is required.
        </b-form-invalid-feedback>
      </b-form-group>
      <div v-if="creatingAnnouncement" class="text-center">
        <b-spinner variant="primary" size="sm" class="mr-2" />
        <span class="text-muted">Publishing announcement...</span>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BFormInvalidFeedback, BSpinner,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'CreateAnnouncementModal',
  components: {
    BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BFormInvalidFeedback, BSpinner,
  },
  props: {
    visible: { type: Boolean, default: false },
    announcementForm: { type: Object, required: true },
    creatingAnnouncement: { type: Boolean, default: false },
  },
  data() {
    return {
      submitAttempted: false,
    }
  },
  computed: {
    hasTitle() {
      return !!(this.announcementForm.title && String(this.announcementForm.title).trim())
    },
    hasDate() {
      return !!this.announcementForm.date
    },
    hasMessage() {
      return !!(this.announcementForm.message && String(this.announcementForm.message).trim())
    },
    titleState() {
      if (!this.submitAttempted) return null
      return this.hasTitle
    },
    dateState() {
      if (!this.submitAttempted) return null
      return this.hasDate
    },
    messageState() {
      if (!this.submitAttempted) return null
      return this.hasMessage
    },
  },
  methods: {
    isValid() {
      return this.hasTitle && this.hasDate && this.hasMessage
    },
    showValidationToast() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Validation Error',
          icon: 'AlertCircleIcon',
          variant: 'warning',
          text: 'Please fill in all fields including title, date, and message.',
        },
      })
    },
    handleOk(bvModalEvt) {
      if (bvModalEvt && typeof bvModalEvt.preventDefault === 'function') {
        bvModalEvt.preventDefault()
      }
      this.submitAttempted = true
      if (!this.isValid()) {
        this.showValidationToast()
        return
      }
      this.$emit('ok', bvModalEvt)
    },
    handleHidden() {
      this.submitAttempted = false
      this.$emit('update:visible', false)
      this.$emit('hidden')
    },
  },
}
</script>
